<template>
    <div>
        <public-menu></public-menu>
        <ranking-content></ranking-content>
        <bottom-content></bottom-content>
        <public-footer></public-footer>
    </div>
</template>

<script>
import Public_menu from "@/components/common/public-top"
import Ranking_content from "@/components/ranking/Index"
import Bottom_content from "@/components/common/bottom-nav"
import Footer from "../../components/Footer.vue"
export default {
    components:{
        'public-menu': Public_menu,
        'ranking-content': Ranking_content,
        'bottom-content': Bottom_content,
        'public-footer': Footer
    }
}
</script>

<style scoped>
@import url('../../assets/css/style.css');
</style>


// WEBPACK FOOTER //
// src/views/ranking/Index.vue